export const HOME_PAGE = "/";
